import { AbstractControl, FormControl, UntypedFormBuilder, UntypedFormGroup, Validators, ValidationErrors, ValidatorFn } from '@angular/forms';
import { ConfigSystemParams, msSize } from 'src/app/core/consts';
import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { catchError, Observable, throwError } from 'rxjs';
import { CompaniesService } from 'src/app/core/services/utelize/system/company/companies-service';
import { CompanyDTO } from 'src/app/core/models/system/company/company.dto';
import { CompletedModalFormComponent } from '../../_pop-ups/completed-modal-form/completed-modal-form.component';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { IdAndDescriptionDTO } from 'src/app/core/interfaces/general/id-description';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { SystemUserDTO } from 'src/app/core/models/system/user/system-user.dto';
import { DevicesService } from 'src/app/core/services/utelize/system/device/devices-service';
import { TicketHubService } from 'src/app/core/services/utelize/system/support/ticket-hub/ticket-hub.service';
import { UsersService } from 'src/app/core/services/utelize/system/user/users-service';


@Component({
  selector: 'app-ticket-modal-form',
  templateUrl: './ticket-modal-form.component.html',
  styleUrls: ['./ticket-modal-form.component.scss'],
})
export class TicketModalFormComponent implements AfterViewInit, OnInit {
  formTitle = 'Create Ticket';
  @Output() ticketFormCancelled          : EventEmitter<void> = new EventEmitter<void>();
  @Output() ticketFormHasBeenSaved       : EventEmitter<void> = new EventEmitter<void>();  
  @Input() embeddedFormMode              : boolean | undefined;
  @Input() initialSureSimCompanyId       : number  | undefined;
  @Input() initialSureSimDeviceId        : number  | undefined;
  @Input() initialSureSimUserId          : number  | undefined;
  
  @ViewChild('createTicketModalForm',   { static: false }) ticketModalForm!   : TemplateRef<void>;
  @ViewChild('completedModalForm',      { static: false }) completedModalForm!: CompletedModalFormComponent;
  
  get modalBackGround    () { let value: string | boolean=this.configSystemService.getValue(ConfigSystemParams.ModalBackGround, "TRUE");
                              return value=value.toUpperCase()=="STATIC" ? "static" : (value.toUpperCase()=="TRUE" ? true : false) }
  
  public ticketFormSubmitted       : boolean = false;
  public ticketForm!               : UntypedFormGroup;
  public curUser                   : SystemUserDTO;
  public suresimUserData!          : IdAndDescriptionDTO[];
  public suresimUserDataPlusSelf!  : IdAndDescriptionDTO[];
  public isCompany                 : boolean = false;
  public isDevice                  : boolean = false;
  public isUser                    : boolean = false;
  public companies!                : CompanyDTO[]
  public suresimCompanyIdData!     : IdAndDescriptionDTO[];
  public ticketModalFormRef!       : NgbModalRef;
  public createTicketButtonEnabled : boolean=false;
  public initialSureSimCompanyIdSet: boolean=false;
  public initialSureSimDeviceIdSet : boolean=false;
  public initialSureSimUserIdSet   : boolean=false;
  public matchCompanyAndUser       : boolean=false

  public typeIdData!               : IdAndDescriptionDTO[];
  public iccidData!                : string[];

  public selectedCompany?    : IdAndDescriptionDTO;
  public selectedcompanyId   : number | undefined;
  public sureSimCompanyId          : number | undefined;

  constructor(
    private authenticationService     : AuthenticationService,
    private companiesService          : CompaniesService,
    private configSystemService       : ConfigSystemService,
    private exceptionsService         : ExceptionsService,
    private formBuilder               : UntypedFormBuilder,
    private usersService              : UsersService,
    private devicesService            : DevicesService,
    private ticketHubService          : TicketHubService,
    private modalService              : NgbModal
  ) {
    this.curUser=this.authenticationService.currentUserObject();
  }

  public ngOnInit(): void {
    try {            
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngOnDestroy() {
    this.closeForm();
  }

  public closeForm(): void {
    try {
      this.ticketFormCancelled.emit();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngAfterViewInit(): void {
    try {      
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public resetMainVariables(): void {
    try {
      this.ticketFormSubmitted        = false;
      this.initialSureSimCompanyIdSet = false;
      this.initialSureSimDeviceIdSet  = false;
      this.initialSureSimUserIdSet    = false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  get formData() {
    return this.ticketForm.controls;
  }

  public getTicketTypes() {
    this.typeIdData = [];
    this.typeIdData.push({id:1, description:"Billing Query"});
    this.typeIdData.push({id:2, description:"Customer Query"});
    this.typeIdData.push({id:3, description:"Fault"});
  }

  public openForm(companies: CompanyDTO[], isCompany: boolean, isDevice: boolean, isUser: boolean, matchCompanyAndUser: boolean, initialSureSimCompanyId: number, initialSureSimUserId: number, initialSureSimDeviceId: number): void {
    try {
      this.companies              = companies;
      this.isCompany              = isCompany;
      this.isDevice               = isDevice;
      this.isUser                 = isUser;
      this.initialSureSimCompanyId= initialSureSimCompanyId;
      this.initialSureSimDeviceId = initialSureSimDeviceId;
      this.initialSureSimUserId   = initialSureSimUserId;
      this.suresimCompanyIdData   = companies.map(x => ({id: x.id, description: x.companyName}));
      this.matchCompanyAndUser    = matchCompanyAndUser;
      this.getTicketTypes();
      this.openModal();
      this.setUpForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onDetailsChange(newValue : string) {
      this.ticketForm.get('details')!.updateValueAndValidity();
  }

  public onHighPriorityCheckboxChange(event: Event) {
    try {
      const isChecked = (event.target as HTMLInputElement).checked;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpForm() {
    try {
      this.buildForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private buildForm() {
    try {
      this.removeFormFields(this.ticketForm);
      this.ticketForm         =this.formBuilder.group({ });
      this.addFormFields(this.ticketForm);
      this.enableDisableControls(false);

      this.ticketForm.valueChanges.subscribe(changedValues => { this.createTicketButtonEnabled = this.ticketForm.valid });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private removeFormFields(form: UntypedFormGroup) {
    try {
      if (form != undefined) {
        for (let control in form.controls) {
          form.removeControl(control);
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private addFormFields(formGroup: UntypedFormGroup) {
    try {
      this.addFormControl(formGroup, "affectedUserId",      "",   [this.affectedUserRequiredValidator()]);
      this.addFormControl(formGroup, "highPriority",        "",   []);
      this.addFormControl(formGroup, "companyId",           "",   [Validators.required]);
      this.addFormControl(formGroup, "userId",              "",   [Validators.required]);
      this.addFormControl(formGroup, "iccid",               "",   [this.iccidRequiredValidator(this.iccidData)]);
      this.addFormControl(formGroup, "typeId",              "",   [Validators.required]);
      this.addFormControl(formGroup, "title",               "",   [Validators.required]);
      this.addFormControl(formGroup, "details",             "",   [Validators.required]);
      
      if (this.initialSureSimCompanyId ?? -1 > 0) {
        this.ticketForm.controls["companyId"].setValue(this.initialSureSimCompanyId);
        this.companySelectDropDownChange(undefined);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private addFormControl(form      : UntypedFormGroup,
                          dataField : string,
                          value     : boolean | number | string,
                          validators: Validators) {
    try {
      form.addControl(dataField, new FormControl(
        value,
        validators
      ));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public affectedUserRequiredValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      try {
        const value =control.value;
        const parent=control.parent;
        if (!parent) return null;
  
        const typeControl = parent.get("typeId");
        var result = typeControl && typeControl.value != 3 || (value != null && value != '') ? null : { affectedUserRequired: true };
        return result;
      } catch (e) {
        this.exceptionsService.handleException(<Error>e);
        return null;
      }
    }
  } 

  public iccidRequiredValidator(options: any[]): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      try {
        const value =control.value;
        const parent=control.parent;
        if (!parent) return null;
  
        const typeControl = parent.get("typeId");
        var result = options == undefined || options.length == 0 || typeControl && typeControl.value != 3 || (value != null && value != '') ? null : { affectedUserRequired: true };
        return result;
      } catch (e) {
        this.exceptionsService.handleException(<Error>e);
        return null;
      }
    }
  }

  private openModal(): void {
    try {
      this.ticketModalFormRef=this.modalService.open(this.ticketModalForm, { backdrop: this.modalBackGround, 
                                                                         centered: true,
                                                                         keyboard: false,
                                                                         size    : msSize.Large });
    }
    catch(e) {
      this.ticketFormCancelled.emit();
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public ticketFormSubmit() {
    try {
      this.ticketFormSubmitted=true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public ticketFormCancel() {
    try {
      this.ticketFormCancelled.emit();
      this.ticketModalFormRef.close();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public getDropdownDataObjectArray_user() {
    try {
      return this.suresimUserData;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
       return undefined;
    }
  }

  public companySelectDropDownChange(ev: any) {
      try {
        this.resetMainVariables();
        this.enableDisableControls(true);
        this.ticketForm.controls["userId"].setValue("");
        this.ticketForm.controls["affectedUserId"].setValue("");
        this.ticketForm.controls["iccid"].setValue("");
        this.ticketForm.get('affectedUserId')!.updateValueAndValidity();
        this.ticketForm.get('iccid')!.updateValueAndValidity();
 
        this.selectedCompany=this.suresimCompanyIdData.find(x => x.id==this.ticketForm.get('companyId')?.value);
        let gotCompany            =this.selectedCompany?.id!=undefined && <number>this.selectedCompany?.id>0;      
  
        if (gotCompany) {
          this.selectedcompanyId=<number>this.companies.find(x => x.id == <number>this.selectedCompany?.id)?.id;
          this.companiesService.getIdByCompanyName(this.selectedCompany?.description ?? "")
          .pipe(
            catchError((error) => {
              return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
            })
          )
          .subscribe({
            next: data => {
              this.sureSimCompanyId=data.result;
              this._refreshUserData();
            },
            error: error => {
              this.exceptionsService.handleException(new Error(error));
            }
          });
        }
      }
      catch(e) {
        this.exceptionsService.handleException(<Error>e);
      }
    }

  public typeDropDownChange(ev: any) {
    try {
      this.ticketForm.get('affectedUserId')!.updateValueAndValidity();
      this.ticketForm.get('iccid')!.updateValueAndValidity();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private enableDisableControls(enabled: boolean) {
    try {
      if (enabled) {
        if (Number(this.initialSureSimCompanyId ?? -1) <= Number(0)) {
           this.ticketForm.controls["companyId"].enable();
        }
        this.ticketForm.controls["userId"].enable();
        if (Number(this.initialSureSimUserId ?? -1) <= Number(0)) {
          this.ticketForm.controls["affectedUserId"].enable();
        }
        if (Number(this.initialSureSimDeviceId ?? -1) <= Number(0)) {
          this.ticketForm.controls["iccid"].enable();
        }
      } else if (this.initialSureSimCompanyId == undefined || Number(this.initialSureSimCompanyId) <= Number(0)) {
        this.ticketForm.controls["affectedUserId"].disable();
        this.ticketForm.controls["iccid"].disable();
        this.ticketForm.controls["userId"].disable();
      } else {
        if (Number(this.initialSureSimCompanyId ?? -1) > Number(0)) {
           this.ticketForm.controls["companyId"].disable();
        }
        if (Number(this.initialSureSimUserId ?? -1) > Number(0)) {
          this.ticketForm.controls["affectedUserId"].disable();
        }
        if (Number(this.initialSureSimDeviceId ?? -1) > Number(0)) {
          this.ticketForm.controls["iccid"].disable();
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
   
  public _refreshUserData() {
    try {
      if (this.selectedcompanyId != undefined && this.selectedcompanyId>0) {
        this.getDropdownData(this.usersService.getIdAndFullNameByCompanyId(<number>this.selectedCompany?.id), "userId");
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public userSelectDropDownChange(ev: any) {
    try {
      this.getICCIDs();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private getDropdownData(dataSource: Observable<any>, fieldName: string) {
      try {
        if (dataSource) {
          dataSource
          .pipe(
            catchError((error) => {
              return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
            })
          )
          .subscribe({
            next: data => {
              if (fieldName=="userId") {
                this.suresimUserData=(data as IdAndDescriptionDTO[]);

                if (!this.initialSureSimUserIdSet && this.initialSureSimUserId != undefined && this.initialSureSimUserId>0) {
                  this.ticketForm.controls["affectedUserId"].setValue(this.initialSureSimUserId);
                  
                  this.initialSureSimUserIdSet=true;
                }

                this.suresimUserDataPlusSelf = JSON.parse(JSON.stringify(data)) as IdAndDescriptionDTO[];
                if (this.curUser.companyId != this.selectedCompany?.id)
                {
                  this.suresimUserDataPlusSelf.push({id:this.curUser.userId,description:this.curUser.firstname + ' ' + this.curUser.lastname});
                }
                this.ticketForm.controls["userId"].setValue(this.curUser.userId);
                this.userSelectDropDownChange(undefined);
                this.ticketForm.get('iccid')!.updateValueAndValidity();
              } else if (fieldName=="iccid") {
                this.iccidData=(data.map((x: { description: string; }) => x.description) as string[]);

                if (!this.initialSureSimDeviceIdSet && this.initialSureSimDeviceId != undefined && this.initialSureSimDeviceId>0) {
                  let deviceData=(data as IdAndDescriptionDTO[]);
                  let device=deviceData.find(x => x.id == this.initialSureSimDeviceId);
                  if (device != undefined) {
                    this.ticketForm.controls["iccid"].setValue(device.description);
                  }
                  
                  this.initialSureSimDeviceIdSet=true;
                }
              }
             },
            error: error => {
              this.exceptionsService.handleException(new Error(error));
            }
          });
        }
      }
      catch(e) {
        this.exceptionsService.handleException(<Error>e);
      }
  }

  public canSubmit() {
      var result = this.ticketForm.valid && (this.ticketForm.controls['typeId'].value != 3 || 
                                              (this.ticketForm.controls['affectedUserId'].value > 0 && this.ticketForm.controls['iccid'].value.toString() != "") || 
                                              (this.ticketForm.controls['affectedUserId'].value > 0 && (this.iccidData == undefined ||this.iccidData.length == 0)));

      return result;
  }

  public saveFormData() {
    try {
      this.ticketFormSubmitted=true;
      this.ticketForm.get('affectedUserId')!.updateValueAndValidity();
      this.ticketForm.get('iccid')!.updateValueAndValidity();
      if (this.ticketForm.valid) {
        let ticketIssueType = this.typeIdData.find(x => x.id == this.ticketForm.controls['typeId'].value)?.description;
        this.ticketHubService.post({
          AffectedUserId : this.ticketForm.controls['affectedUserId'].value as number, 
          CompanyId      : this.ticketForm.controls['companyId'].value as number,
          HighPriority   : this.ticketForm.controls['highPriority'].value as boolean,
          UserId         : this.ticketForm.controls['userId'].value as number,
          TypeID         : this.ticketForm.controls['typeId'].value as number,
          EnteredBy      : this.curUser.userId,
          Type           : ticketIssueType?.toString(),
          ICCID          : this.ticketForm.controls['iccid'].value.toString(),
          Title          : this.ticketForm.controls['title'].value.toString(),
          Details        : this.ticketForm.controls['details'].value.toString(),
        })
        .subscribe({
                next: data => {
                  this.ticketFormSubmitted = false;
                  this.completedModalForm.openForm("Congratulations", "Ticket has been created");
                  this.ticketFormHasBeenSaved.emit();
                  this.ticketModalFormRef.close();
                }
              });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public getICCIDs() {
    this.ticketForm.controls["iccid"].setValue("");
    let userId = this.ticketForm.controls["affectedUserId"].value as number;
    if(userId > 0){
      this.getDropdownData(this.devicesService.getIdAndDescriptionForUser(userId), "iccid");
    }
  }

  public completedModalHasBeenClosed() {
    this.setUpForm();
  }
}
